import isFunction from 'lodash-es/isFunction'
import waitForCondition from '@/utils/wait-for-condition'

type LifecycleFn =
  | undefined
  | (() => void)
  | (() => () => boolean)
  | (() => Promise<void>)

type CheckLifecycleIsReady = (
  lifecycleFn: LifecycleFn,
  options?: {
    // auto cancel only support () => () => boolean
    onStart?: (cancelFn: () => void) => void
    onResolve?: (cancelFn: () => void) => void
  },
) => Promise<void>

const checkLifecycleIsReady: CheckLifecycleIsReady = async (
  lifecycleFn,
  { onStart = (): void => {}, onResolve = (): void => {} } = {},
) => {
  if (!lifecycleFn) {
    return
  }

  const check = lifecycleFn()
  if (!check) {
    return
  }

  if (isFunction(check)) {
    const { promise, cancel } = waitForCondition(check)
    onStart(cancel)
    return await promise.then(() => onResolve(cancel))
  }

  return await check
}

export type { LifecycleFn }
export default checkLifecycleIsReady
